var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventDispatcher } from "./EventDispatcher";
import { getErrorMessage } from "./utils/errorHelper";
var axiosModule = require("axios");
var Gate = /** @class */ (function (_super) {
    __extends(Gate, _super);
    function Gate() {
        var _this = _super.call(this) || this;
        _this.token = null;
        _this.profileId = null;
        _this.axios = axiosModule.create();
        return _this;
    }
    Gate.prototype.setToken = function (token) {
        this.token = token;
    };
    Gate.prototype.getToken = function () {
        return this.token;
    };
    Gate.prototype.setProfileId = function (profileId) {
        this.profileId = profileId;
    };
    Gate.prototype.getProfileId = function () {
        return this.profileId;
    };
    Gate.prototype.request = function (urlPath, data) {
        var _a;
        if (data === void 0) { data = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var url, request, errorMessage, responseData, response, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = urlPath;
                        request = {
                            method: "post",
                            url: url,
                            responseType: "json",
                            headers: {
                                "Content-Type": "application/json",
                                Accept: "application/json"
                            }
                        };
                        /**
                         * If JWT exists in localstorage, adding "Authorization" header
                         * with JWT from localstore.
                         */
                        if (this.token) {
                            request.headers.Authorization = "Bearer ".concat(this.token);
                        }
                        if (this.profileId) {
                            request.headers["x-profile-id"] = this.profileId;
                        }
                        if (data.method) {
                            request.method = data.method;
                        }
                        if (data.data) {
                            request.data = data.data;
                        }
                        errorMessage = null;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axios(request)];
                    case 2:
                        response = _b.sent();
                        responseData = response.data;
                        this.dispatch(responseData);
                        return [2 /*return*/, responseData];
                    case 3:
                        error_1 = _b.sent();
                        errorMessage = getErrorMessage(error_1);
                        if (error_1.response) {
                            errorMessage = ((_a = error_1.response.data) === null || _a === void 0 ? void 0 : _a.message) || errorMessage;
                            responseData = error_1.response.data;
                        }
                        else {
                            // Network level errorMessage. Server is down or something
                            errorMessage = error_1.message;
                            responseData = { success: false, errors: [{ message: errorMessage }] };
                        }
                        throw responseData;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return Gate;
}(EventDispatcher));
export { Gate };
//# sourceMappingURL=data:application/json;base64,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